<template>
	<div>
		<div class="title-box">
			<div class="title-line"></div>
			<div class="title-name">{{title}}</div>
			<div class="title-line"></div>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				
			}
		},
		props:{
			title:{
				type: String,
				default: '新品发布',
			}
		}
	}
</script>
<style scoped>
	.title-box{
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 80px;
	}
	.title-line{
		width: 63px;
		height: 4px;
		background: #0097FE;
	}
	.title-name{
		font-size: 36px;
		color: #333;
		margin: 0 30px;
	}
</style>


// WEBPACK FOOTER //
// src/components/title.vue